import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faTimes } from '@fortawesome/free-solid-svg-icons';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import Dropdown from '../../../components/Common/Dropdown';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import IconUpload from '../../../assets/icons/IconUpload';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_IMPORT_VIEW } from '../../../constants/menuPermissionConstant';

class Import extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageCompanyProfile: undefined,
            dataType: {
                data: [],
                value: ''
            },
            template: undefined,
            file: undefined,
            fileName: undefined,
            importAndValidateData: [],
            showModal: false,
            showSuccessAlert: false,
            successMessage: '',
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateImport = () => {
        API_MASTER_DATA.getInitiateImport(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        messageCompanyProfile: getContent(res).message['company-profile'],
                        dataType: {
                            ...this.state.dataType,
                            data: getContent(res).list_data_type
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getInitiateMessage = () => {
        API_MASTER_DATA.getInitiateImport(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        messageCompanyProfile: getContent(res).message[this.state.dataType.value],
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getTemplateImport = () => {
        API_MASTER_DATA.getTemplateImport(this.props.token, this.state.dataType.value)
            .then(res => {
                if (this._isMounted) {
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(new Blob([res.data], { type: "application/octet-stream" }));
                    link.download = res.headers && res.headers["content-disposition"].split("filename=")[1].split(";")[0];
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(link);
                    }, 150);
                }
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeDataType = data => {
        this.setState({
            dataType: {
                ...this.state.dataType,
                value: data.value
            }
        })
        this.getInitiateMessage();
    }

    handleChangeFile = event => {
        this.setState({
            file: event.target.files[0]
        });
    }

    handleRemoveFile = () => {
        this.setState({
            file: undefined
        });
    }

    handleImportAndValidate = () => {
        const input = this.state.file.name;
        const period = input.lastIndexOf('.');
        const fileExtension = input.substring(period + 1);

        if (fileExtension !== 'csv') {
            return this.setState({ showErrorAlert: true })
        }

        const form = new FormData();
        const content = {
            type: this.state.dataType.value
        }

        form.append('file', this.state.file)
        form.append('content', JSON.stringify(content))

        API_MASTER_DATA.postDataImportValidate(form, this.props.token)
            .then(res => {
                this.setState({
                    showModal: true,
                    importAndValidateData: getContent(res).Data,
                    fileName: getContent(res).Filename
                })
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleImportConfirm = importConfirm => {
        const data = {
            type: this.state.dataType.value,
            filename: this.state.fileName,
            confirm: importConfirm
        }

        if (importConfirm) {
            return API_MASTER_DATA.postDataImportConfirm(data, this.props.token)
                .then(res => {
                    this.setState({
                        showSuccessAlert: true,
                        successMessage: getContent(res)
                    })
                }).catch(err => {
                    this.setState({ errorMessage: getErrorMessage(err) })
                    this.setState({ showErrorAlertResponse: true })
                    if (err.response?.status === 401) {
                        this.props.history.push(ROUTER_CONSTANT.LOGIN);
                        this.props.handleLogout();
                    }
                })
        }

        API_MASTER_DATA.postDataImportConfirm(data, this.props.token)
            .then(res => {
                this.setState({ showModal: false })
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateImport();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_IMPORT_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="flex text-gray-600 calculate-layout">
                    <div className="w-full bg-white rounded-lg p-5 relative">
                        <div className="border-b-2 border-gray flex" style={{ height: "90%" }}>
                            <div className="w-1/3">
                                <p className="text-darkblue font-bold mb-5">Import</p>
                                <div className="mb-5 ml-0.5">
                                    <label>Tipe Data</label>
                                    <Dropdown
                                        id="ddldatatype"
                                        placeholder="Pilih Tipe Data"
                                        handleChange={this.handleChangeDataType}
                                        data={this.state.dataType.data.map(data => ({ value: data, label: data.replace('-', ' ') }))}
                                    />
                                </div>
                                <div className={this.state.dataType.value === '' ? "hidden" : "ml-0.5"}>
                                    <label>File Data</label>
                                    <div className="w-full h-48 form-control bg-lightgrey flex flex-col items-center text-sm relative">
                                        <div className="my-1 2xl:my-3"><IconUpload /></div>
                                        <p>Seret dan letakan file di sini</p>
                                        <p>Atau</p>
                                        <p className="text-darkblue font-medium">Ambil File</p>
                                        <input type="file" name="file" id="fupimport" className="h-full w-full bg-red-100 absolute top-0 left-0 opacity-0 cursor-pointer" accept=".csv" onChange={this.handleChangeFile} />
                                    </div>
                                    {
                                        this.state.file !== undefined
                                        && <div className="flex justify-between items-center text-xs bg-blue-100 rounded mt-2 py-1 px-2">
                                            {this.state.file.name}
                                            <FontAwesomeIcon icon={faClose} className="cursor-pointer" id="btnremovefile" onClick={() => this.handleRemoveFile()} />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={this.state.dataType.value === '' ? "hidden" : "w-2/3 pl-5 pt-16"}>
                                <div className="w-full h-4/5 border-only mt-1">
                                    <div className="bg-blue-50 w-full h-1/6 p-3">
                                        <p className="font-medium">Tidak Memiliki Templatenya?</p>
                                        <p className="text-lightblue text-sm cursor-pointer" id="btntemplateimport" onClick={() => this.getTemplateImport()}>Unduh di sini</p>
                                    </div>
                                    <div className="w-full h-5/6 p-3 overflow-y-auto">
                                        <p className="font-medium">Aturan Pada Kolom Template</p>
                                        <div className="text-sm mt-2" dangerouslySetInnerHTML={{ __html: `${this.state.messageCompanyProfile}` }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="absolute bottom-5 right-5">
                            <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => window.location.reload()}>Batal</button>
                            <button type="submit" id="btnimport" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleImportAndValidate()}>Import</button>
                        </div>
                    </div>
                    <div className={this.state.showModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 w-2/3 max-h-2/3 relative">
                                <div className="header flex justify-between">
                                    <div></div>
                                    <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btncloseimport" onClick={() => this.handleImportConfirm(false)} />
                                </div>
                                <div className="flex justify-between items-center">
                                    <p className="font-bold my-5">Apakah Anda Yakin Akan Mengunggah Data Company - Profile Ini?</p>
                                    <div></div>
                                </div>
                                <div className="overflow-auto mb-10 text-left" style={{ maxHeight: "40em" }}>
                                    <table>
                                        <tbody>
                                            {
                                                this.state.importAndValidateData.map((data, idx) =>
                                                    idx === 0
                                                        ? <tr key={idx} className="bg-gray-300">
                                                            {
                                                                data.map((item, i) =>
                                                                    <th className="p-5" key={i}>{item}</th>
                                                                )
                                                            }
                                                        </tr>
                                                        : <tr key={idx} className="bg-gray-100">{
                                                            data.map((item, i) =>
                                                                <td className="p-5 font-bold" key={i}>{item}</td>
                                                            )
                                                        }
                                                        </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="absolute bottom-5 right-5">
                                    <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.handleImportConfirm(false)}>Batal</button>
                                    <button type="submit" id="btnimport" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleImportConfirm(true)}>Setuju</button>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>
                    <Alert show={this.state.showSuccessAlert} icon="success" title={`Berhasil mengimport data! Berikut job process id ${this.state.successMessage}`} close={() => window.location.reload()} ok />
                    <Alert show={this.state.showErrorAlert} icon="warning" title="Format File yang Anda Masukan Tidak Sesuai!" close={() => this.setState({ showErrorAlert: false })} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Import);